// modules
import { handleActions } from 'redux-actions'

// actions
import { setPatientList } from 'src/store/modules/admin/activityLog'

const initialState = {
  currentPatientUuid: null,
  isStartModalOpen: false,
  patientList: [],
  stopTimerInitialValue: {}
}

export default handleActions(
  {
    [setPatientList](state, { payload: patientList }) {
      return {
        ...state,
        patientList
      }
    }
  },
  initialState
)
